export default function prepareDateTimeOptions(options) {
    return [
        {value: '', label: 'None'},
        ...options.map(value => ({value, label: value})),
    ];
}
